import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../../common/GridLayout";
import LocationSubTabs from "./LocationSubTabs";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    Lookup,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../../gridLayoutCustomization/GridLayoutManager";
const LocationSearchFormResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "dc96adca-c885-497d-81b8-06753eff86a7";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="warehouse" caption='Warehouse' dataType="string" ></Column>
                <Column dataField="location" caption='Location' dataType="string"></Column>
                <Column dataField="description" caption='Description' dataType="string"></Column>
                <Column dataField="classcode" caption='Class Code' dataType="string"></Column>
                <Column dataField="subclasscode" caption='Sub Class Code' dataType="string"></Column>
                <Column dataField="dimensions" caption='Dimensions' dataType="string"></Column>
                <Column dataField="height" caption='Height' dataType="number"></Column>
                <Column dataField="width" caption='Width' dataType="number"></Column>
                <Column dataField="depth" caption='Depth' dataType="number"></Column>
                <Column dataField="status" caption="Status" dataType="string" visible={false}>
                <Lookup
                        dataSource={[
                            { ID: "A", Text: "Allow All Receipts/Shipments" },
                            { ID: "R", Text: "Allow Receipts Only" },
                            { ID: "S", Text: "Allow Shipments Only" },
                            { ID: "N", Text: "Receipts/Shipments Not Allowed" }
                        ]}
                        displayExpr="Text"
                        valueExpr="ID"
                    />
                </Column>
                <Column dataField="userDefinedCode1" caption="Code 1" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode2" caption="Code 2" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode3" caption="Code 3" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode4" caption="Code 4" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode5" caption="Code 5" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode6" caption="Code 6" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode7" caption="Code 7" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode8" caption="Code 8" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode9" caption="Code 9" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode10" caption="Code 10" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference1" caption="Reference 1" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference2" caption="Reference 2" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference3" caption="Reference 3" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference4" caption="Reference 4" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference5" caption="Reference 5" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference6" caption="Reference 6" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference7" caption="Reference 7" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference8" caption="Reference 8" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference9" caption="Reference 9" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedReference10" caption="Reference 10" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedDate1" caption="Date 1" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate2" caption="Date 2" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate3" caption="Date 3" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate4" caption="Date 4" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate5" caption="Date 5" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate6" caption="Date 6" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate7" caption="Date 7" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate8" caption="Date 8" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate9" caption="Date 9" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate10" caption="Date 10" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedQuantity1" caption="Quantity 1" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity2" caption="Quantity 2" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity3" caption="Quantity 3" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity4" caption="Quantity 4" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity5" caption="Quantity 5" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity6" caption="Quantity 6" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity7" caption="Quantity 7" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity8" caption="Quantity 8" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity9" caption="Quantity 9" dataType="number" visible={false}></Column>
                <Column dataField="userDefinedQuantity10" caption="Quantity 10" dataType="number" visible={false}></Column>
                <Column dataField="priority" caption="Priority" dataType="string" visible={false}></Column>
                <Column dataField="creationDateTime" caption="Creation Date" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="creationUserId" caption="Created By" visible={false} dataType="string"></Column>
                <Column dataField="lastUpdateDateTime" caption="Last Updated" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="lastUpdateUserId" caption="Last Updated By" visible={false} dataType="string"></Column>
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <LocationSubTabs ref={childRef} accessToken={accessToken} />
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationSearchFormResult);